module.exports = __webpack_public_path__ + "static/media/video.be83390e.mp4";